import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from "@angular/core";
import { KzMeshLinkComponent } from './mesh-link/kz-mesh-link.component';
import { MediaQueriesService } from '../../../shared/services/utilities/media-queries.service';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
@Component({
  selector: "kz-mesh-link-container",
  templateUrl: "./kz-mesh-link-container.component.html",
  styleUrls: ["./kz-mesh-link-container.component.scss"],
  host: {
    '[class]': '"kz-mesh-link--container " + classes ',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class KzMeshLinkContainerComponent implements AfterViewInit, OnInit {

  private _classes = '';

  get classes(): string {
    return this._classes;
  }

  private _meshLinkBreakPointVersion: 'stacked' | 'default' = 'stacked';

  @Input()
  set meshLinkBreakPointVersion(val: 'stacked' | 'default') {
    this._meshLinkBreakPointVersion = val;
  }

  get meshLinkBreakPointVersion(): 'stacked' | 'default' {
    return this._meshLinkBreakPointVersion;
  }

  private _meshLinkBreakPointLimit = 2;

  @Input()
  set meshLinkBreakPointLimit(val: number) {
    this._meshLinkBreakPointLimit = val;
  }

  get meshLinkBreakPointLimit(): number {
    return this._meshLinkBreakPointLimit;
  }

  private _meshLinkBreakPoint = 768;

  @Input()
  set meshLinkBreakPoint(val: number) {
    this._meshLinkBreakPoint = val;
  }

  get meshLinkBreakPoint(): number {
    return this._meshLinkBreakPoint;
  }

  public mobileVersion$: Observable<boolean>;

  public allLinksInMobile = false;

  @ContentChildren(KzMeshLinkComponent) items: QueryList<KzMeshLinkComponent>;
  @ViewChildren(KzMeshLinkComponent) itemsView: QueryList<KzMeshLinkComponent>;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private mediaQueriesService: MediaQueriesService,
    private _changeDetectorRef: ChangeDetectorRef,
    ) {
  }
  ngOnInit() {

    this.mobileVersion$ = (isPlatformBrowser(this.platformId)
      ? this.mediaQueriesService.isLesserThan(this.meshLinkBreakPoint)
      : of(false)).pipe(
      tap((isMobile) => this._classes = isMobile && this.meshLinkBreakPointVersion === 'stacked' ? 'kz-mesh-link--container--mobile' : '}'),
      tap((isMobile) => {
        this.items.map(
          (item, index) => {
            if (index > (this.meshLinkBreakPointLimit - 1)) {
              item.elementRef.nativeElement.style.display = isMobile ? 'none' : 'inline-block';
            }
          }
        );
      }),
      tap(() => this._changeDetectorRef.detectChanges()),
    );
  }

  ngAfterViewInit() {
    this.items.map((item, index) => {
      // Important: meshLinkBreakPointVersion init must be done before meshLinkBreakPoint init
      item.meshLinkBreakPointVersion = this.meshLinkBreakPointVersion;
      item.meshLinkBreakPoint = this.meshLinkBreakPoint;
    });
  }

  toggle() {
    this.allLinksInMobile = !this.allLinksInMobile;
    this.items.map(
      (item, index) => {
        if (index > (this.meshLinkBreakPointLimit - 1)) {
          item.elementRef.nativeElement.style.display = this.allLinksInMobile ? 'flex' : 'none'
        }
      }
    );
    this._changeDetectorRef.detectChanges();
  }
}
